import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CopyLinkBoxMobile from "../components/CopyLinkBoxMobile"; // Assure-toi que ce composant existe


const EventSuccessMobile = () => {
  const { t } = useTranslation();
  const { id_user, id_admin } = useParams();
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error("Erreur lors de la copie :", err);
    });
  };

  return (
    <div className="p-4 space-y-6">
      <h1 className="text-xl font-bold text-gray-800">
        {t("event_success.title")}
      </h1>

      {/* Lien utilisateur */}
      <div className="bg-gray-100 p-3 rounded border border-gray-300">
        <h2 className="text-md font-semibold mb-2">{t("event_success.user_link_title")}</h2>
        <div className="flex items-center gap-2 mb-2">
		<CopyLinkBoxMobile eventIdUser={id_user} />
        </div>
        <p className="text-green-600 text-sm mt-2">
          {t("event_success.user_link_info")}
        </p>
      </div>

      {/* Lien admin */}
      <div className="bg-gray-100 p-3 rounded border border-gray-300">
        <h2 className="text-md font-semibold mb-2">{t("event_success.admin_link_title")}</h2>
	  </div>
    </div>
  );
};

export default EventSuccessMobile;
